import BrandInitialIndexType from './initialIndexType'

enum BrandIndexType {
  KOREAN = 'KOREAN',
  ENGLISH = 'ENGLISH',
  ETC = 'ETC',
}

export { BrandInitialIndexType, BrandIndexType }

export const BRAND_LIST_PAGE_SIZE = 10

export const BRAND_ALL = '작가 전체보기'
